<template>
<svg width="26px" height="19px" viewBox="0 0 26 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0,0 L0,0.453807692 L0,16.3370769 L22.6903846,16.3370769 L22.6903846,0 L0,0 Z M0.907615385,0.907615385 L21.7827692,0.907615385 L21.7827692,2.04479377 C21.5902247,2.21261371 13.5297336,9.23769877 12.8590669,9.82156881 C12.270412,10.3340398 11.6707184,10.4384633 11.3451923,10.4384633 C11.01999,10.4384633 10.4200589,10.3341154 9.83131771,9.82156881 C9.16065098,9.23769877 1.10015988,2.21261371 0.907615385,2.04479377 L0.907615385,0.907615385 Z M0.907615385,3.24490281 C2.0139866,4.20931979 8.60766508,9.95741654 9.2365815,10.5049395 C10.0083558,11.176831 10.8254034,11.3443059 11.3451923,11.3443059 C11.8646562,11.3443059 12.6819412,11.1769053 13.4538031,10.5049395 C14.0827182,9.95741787 20.6763529,4.21012921 21.7827692,3.24578919 L21.7827692,15.4294615 L0.907615385,15.4294615 L0.907615385,3.24490281 Z">
                    </path>
</svg>
</template>
<script>
export default {
    name: 'icon-mail',
};
</script>
<style>

</style>
